import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsTicketingFeatureEnabled } from 'containers/Home/selectors';

export const AccountFeatureGuard = ({
  feature,
  redirectPath = '/app',
  children,
}: {
  feature: 'ticketing';
  redirectPath?: string;
  children: React.ReactNode;
}) => {
  const isTicketingFeatureEnabled = useSelector(
    selectIsTicketingFeatureEnabled()
  );

  let isFeatureEnabled = false;

  switch (feature) {
    case 'ticketing':
      isFeatureEnabled = isTicketingFeatureEnabled;
      break;
    default:
      isFeatureEnabled = false;
  }

  return isFeatureEnabled ? (
    <>{children}</>
  ) : (
    <Navigate to={redirectPath} replace />
  );
};
